import { render, staticRenderFns } from "./HomepagesQuickButtons.vue?vue&type=template&id=565095b4&"
import script from "./HomepagesQuickButtons.vue?vue&type=script&lang=js&"
export * from "./HomepagesQuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565095b4')) {
      api.createRecord('565095b4', component.options)
    } else {
      api.reload('565095b4', component.options)
    }
    module.hot.accept("./HomepagesQuickButtons.vue?vue&type=template&id=565095b4&", function () {
      api.rerender('565095b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/sitecontent/HomepagesQuickButtons.vue"
export default component.exports